import script from "./AnswerModelInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerModelInfo.vue?vue&type=script&setup=true&lang=js"

import "./AnswerModelInfo.vue?vue&type=style&index=0&id=1f94d8f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f94d8f3"]])

export default __exports__